import { schema } from 'normalizr';

export const colorPattern = new schema.Entity('colorPatterns');

export const colorPatternList = new schema.Array(colorPattern);
